// extracted by mini-css-extract-plugin
export var customText = "s_sJ d_dv d_cs d_cg";
export var videoIframeStyle = "s_qg d_d5 d_w d_H d_by d_b1 d_R";
export var customImageWrapper = "s_sK d_cs d_cg d_Z";
export var customRow = "s_qB d_bD d_bf";
export var quoteWrapper = "s_gQ d_bC d_bP d_cs d_cg";
export var quoteBar = "s_ql d_H";
export var masonryImageWrapper = "s_qs";
export var title = "s_pJ";
export var Title3Small = "s_rx q_rx q_qW q_q3";
export var Title3Normal = "s_ry q_ry q_qW q_q4";
export var Title3Large = "s_rz q_rz q_qW q_q5";